// Generated by purs version 0.14.4
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Int from "../Data.Int/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Ring from "../Data.Ring/index.js";
import * as Data_Semiring from "../Data.Semiring/index.js";
var zero = function (dict) {
    return dict.zero;
};
var sub = function (dict) {
    return dict.sub;
};
var scaleIntNumber = {
    scale: (function () {
        var $10 = Data_Semiring.mul(Data_Semiring.semiringNumber);
        return function ($11) {
            return $10(Data_Int.toNumber($11));
        };
    })()
};
var scaleIntInt = {
    scale: Data_Semiring.mul(Data_Semiring.semiringInt)
};
var scale = function (dict) {
    return dict.scale;
};
var negate = function (dictAdditive) {
    return function (n) {
        return sub(dictAdditive)(zero(dictAdditive))(n);
    };
};
var additiveNumber = {
    zero: 0.0,
    add: Data_Semiring.add(Data_Semiring.semiringNumber),
    sub: Data_Ring.sub(Data_Ring.ringNumber)
};
var additiveInt = {
    zero: 0,
    add: Data_Semiring.add(Data_Semiring.semiringInt),
    sub: Data_Ring.sub(Data_Ring.ringInt)
};
var add = function (dict) {
    return dict.add;
};
var sum = function (dictFoldable) {
    return function (dictAdditive) {
        return Data_Foldable.foldl(dictFoldable)(add(dictAdditive))(zero(dictAdditive));
    };
};
var abs = function (dictOrd) {
    return function (dictAdditive) {
        return function (x) {
            var $9 = Data_Ord.lessThan(dictOrd)(x)(zero(dictAdditive));
            if ($9) {
                return negate(dictAdditive)(x);
            };
            return x;
        };
    };
};
export {
    add,
    scale,
    sub,
    zero,
    negate,
    sum,
    abs,
    additiveInt,
    scaleIntInt,
    additiveNumber,
    scaleIntNumber
};
//# sourceMappingURL=index.js.map
